import React from "react";
import PropTypes from "prop-types";
import {TABS, getSuppressionTab, hasUnliftableReason} from "./adminUpdateUtils";

const bannerStyle = {
    cursor: "pointer",
    marginBottom: "16px",
    width: "100%",
    textAlign: "left",
    border: "none"
};

const getSuppressionMessage = ({email, reasons}) => {
    const forEmail = email ? ` for ${email}` : "";
    const reasonText = (reasons ?? []).join("; ") || "Unknown reason";
    const hint = hasUnliftableReason(reasons)
        ? "This cannot be lifted here. Click here to correct the customer's email."
        : "Click here to view unsuppress options in the Admin Link tab.";

    return `Email marketing is suppressed in Klaviyo${forEmail}: ${reasonText}. ${hint}`;
};

const Banner = ({onClick, children}) => (
    <button type="button" onClick={onClick} className="alert alert-danger" style={bannerStyle}>
        {children}
    </button>
);

Banner.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

const StatusBanners = ({blockStatus, suppressionStatus, onTabClick}) => (
    <>
        {Boolean(blockStatus?.isBlocked) && (
            <Banner onClick={() => onTabClick(TABS.ADMIN)}>
                This account is blocked. Click here to view unblock options in the Admin Link tab.
            </Banner>
        )}

        {Boolean(suppressionStatus?.suppressed) && (
            <Banner onClick={() => onTabClick(getSuppressionTab(suppressionStatus.reasons))}>
                {getSuppressionMessage(suppressionStatus)}
            </Banner>
        )}
    </>
);

StatusBanners.propTypes = {
    blockStatus: PropTypes.shape({
        isBlocked: PropTypes.bool
    }),
    suppressionStatus: PropTypes.shape({
        suppressed: PropTypes.bool,
        email: PropTypes.string,
        reasons: PropTypes.arrayOf(PropTypes.string)
    }),
    onTabClick: PropTypes.func.isRequired
};

StatusBanners.defaultProps = {
    blockStatus: null,
    suppressionStatus: null
};

export default StatusBanners;
